/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The status of the flexPlus ticket.
 */
export const FlexPlusStatusDTO = {
    NOT_FLEXPLUS: 'NOT_FLEXPLUS',
    REDEEMED: 'REDEEMED',
    NOT_REDEEMED: 'NOT_REDEEMED'
} as const;
export type FlexPlusStatusDTO = typeof FlexPlusStatusDTO[keyof typeof FlexPlusStatusDTO];

